import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: null,
  response: null,
  loading: false,
  error: null,
  callTimes: 0,
  message: '',
  isLogin: false,
  token: null
};

// ✅ Fix localStorage handling
const userData =
  localStorage.getItem('user') !== 'undefined' && localStorage.getItem('user') !== undefined
    ? JSON.parse(localStorage.getItem('user'))
    : null;

if (userData) {
  initialState.response = userData;
  initialState.token = userData?.access_token || null;
  initialState.isLogin = true;
} else {
  initialState.response = null;
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    signup: (state) => {
      state.loading = true;
      state.callTimes++;
    },
    signin: (state) => {
      state.loading = true;
      state.callTimes++;
    },
    failed: (state, { payload }) => {
      console.log(payload);
      state.error = true; // ✅ fix
      state.loading = false;
      state.message = payload?.message || payload?.data?.message || 'Something went wrong';
      state.response = null;
    },
    getoneuser: (state) => {
      state.callTimes++;
    },
    successLogin: (state, { payload }) => {
      // ✅ Only save serializable values
      const safeData = {
        ...payload?.data,
        access_token: payload?.data?.access_token,
      };

      localStorage.setItem('user', JSON.stringify(safeData));
      localStorage.setItem('token', payload?.data?.access_token);

      state.loading = false;
      state.response = safeData;
      state.message = payload?.message || 'Login Successful';
      state.token = payload?.data?.access_token;
      state.error = null;
      state.isLogin = true;
    },
    success: (state, { payload }) => {
      const safeData = {
        ...payload?.data,
        access_token: payload?.data?.access_token,
      };

      state.loading = false;
      state.response = safeData;
      state.message = payload?.message || 'Success';
      state.token = payload?.data?.access_token;
      state.error = null;
      state.isLogin = true;
    },
    logout: (state) => {
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      state.response = null;
      state.loading = false;
      state.message = 'Logout Successfully';
      state.isLogin = false;
      state.token = null;
    },
    otpverification: (state) => {
      state.loading = true;
    },
    opdotpverification: (state, { payload }) => {
      console.log('payload', payload);
      state.loading = true;
    },
    clear: (state) => {
      state.response = null;
      state.loading = false;
      state.message = '';
      state.isLogin = false;
      state.token = null;
    },
  },
});

export const {
  signup,
  signin,
  success,
  failed,
  logout,
  otpverification,
  successLogin,
  getoneuser,
  clear,
  opdotpverification,
} = userSlice.actions;

export default userSlice.reducer;
